import React, { useMemo } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { CORES_PIZZA } from './constants';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function GraficoPizza({ titulo, dados }) {
  var chartData = useMemo(function() {
    if (!dados || !dados.length) return null;

    return {
      labels: dados.map(function(d) { return d.dissertativa; }),
      datasets: [
        {
          data: dados.map(function(d) { return d.quantidade; }),
          backgroundColor: CORES_PIZZA.slice(0, dados.length),
          borderWidth: 1,
        },
      ],
    };
  }, [dados]);

  var options = useMemo(function() {
    return {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 1.8,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { font: { size: 11 }, boxWidth: 12, padding: 8 },
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              var label = context.label || '';
              var value = context.parsed;
              var total = context.dataset.data.reduce(function(a, b) { return a + b; }, 0);
              var perc = total > 0 ? ((value / total) * 100).toFixed(2) : '0.00';
              return label + ': ' + perc + '% (' + value.toLocaleString('pt-BR') + ')';
            },
          },
        },
      },
    };
  }, []);

  if (!chartData) return null;

  return (
    <div style={{ maxWidth: '280px', margin: '0 auto' }}>
      <h6 className="mb-2 text-center" style={{ color: '#0747a6', fontSize: '0.85rem' }}>{titulo}</h6>
      <Pie data={chartData} options={options} />
    </div>
  );
}
